module.exports = __webpack_public_path__ + "static/pulse-f1da16178c4230d1b2fc6a3ed48920b8.svg";